import serviceModule from '../services/index';

export default angular.module('Serveture-Controllers', [
  serviceModule.name
]);